"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleOption = exports.getActionForToggling = exports.getOptionGroupForOption = exports.getOptionsForType = exports.getIdForCartItem = exports.getMixerForCartItem = exports.getTotalQuantityForDrink = exports.getCartTotal = exports.getCartItemTotal = void 0;
const getCartItemTotal = (item) => {
    const optionPrice = item.options.reduce((accum, option) => accum + option.price, 0);
    const unitPrice = item.item.price + optionPrice;
    return unitPrice * item.quantity;
};
exports.getCartItemTotal = getCartItemTotal;
const getCartTotal = (items) => {
    return items.reduce((accum, value) => {
        return accum + (0, exports.getCartItemTotal)(value);
    }, 0);
};
exports.getCartTotal = getCartTotal;
const getTotalQuantityForDrink = (items, drink, categoryId) => {
    return items
        .filter((i) => {
        return i.item.drinkId === drink.drinkId && i.sourceCategoryId === categoryId;
    })
        .reduce((accum, value) => {
        return accum + value.quantity;
    }, 0);
};
exports.getTotalQuantityForDrink = getTotalQuantityForDrink;
const getMixerForCartItem = (item) => {
    const mixers = (0, exports.getOptionsForType)(item.options, 'mixer');
    if (mixers && mixers.length) {
        return mixers;
    }
    return null;
};
exports.getMixerForCartItem = getMixerForCartItem;
// exclusive options are options that can be selected only individually for an option type that allows multiple
// an example would be a "Neat" mixer
const isExclusiveOption = (option) => {
    return !!(option.options && option.options.exclusive);
};
// returns a way to identify the "same" items
// same is defined as being the same base item, same options, and same comments
const getIdForCartItem = (item) => {
    const optionKeys = item.options.map((option) => option.optionId).sort();
    return [item.item.drinkId, ...optionKeys, item.comments].filter(Boolean).join('_');
};
exports.getIdForCartItem = getIdForCartItem;
var OptionAction;
(function (OptionAction) {
    OptionAction["concat"] = "concat";
    OptionAction["set"] = "set";
    OptionAction["remove"] = "remove";
    OptionAction["returnExisting"] = "return-existing";
})(OptionAction || (OptionAction = {}));
const getOptionsForType = (options, type) => {
    return options.filter((o) => o.type === type);
};
exports.getOptionsForType = getOptionsForType;
const getOptionGroupForOption = ({ item, option, }) => {
    return item.optionGroups.find((optionGroup) => {
        return !!optionGroup.options.find((o) => {
            return o.optionId === option.optionId;
        });
    });
};
exports.getOptionGroupForOption = getOptionGroupForOption;
const getActionForToggling = ({ item, selectedOptions, option, }) => {
    const optionGroup = (0, exports.getOptionGroupForOption)({ item, option });
    const allSelectedOptionIds = selectedOptions.map((o) => o.optionId);
    const selectedFromGroup = optionGroup.options.filter((o) => {
        return allSelectedOptionIds.includes(o.optionId);
    });
    const isAlreadyAdded = allSelectedOptionIds.includes(option.optionId);
    const allowMultiple = optionGroup.maximumAllowed !== 1;
    const required = optionGroup.required;
    if (isAlreadyAdded && required && selectedFromGroup.length === 1) {
        return OptionAction.returnExisting;
    }
    if (allowMultiple) {
        if (isAlreadyAdded) {
            return OptionAction.remove;
        }
        const hasExclusive = !!selectedFromGroup.filter(isExclusiveOption).length;
        if (isExclusiveOption(option) || hasExclusive) {
            return OptionAction.set;
        }
        return OptionAction.concat;
    }
    else {
        if (!required && isAlreadyAdded) {
            return OptionAction.remove;
        }
        return OptionAction.set;
    }
};
exports.getActionForToggling = getActionForToggling;
const toggleOption = ({ item, selectedOptions, option, }) => {
    const action = (0, exports.getActionForToggling)({
        item,
        selectedOptions,
        option,
    });
    switch (action) {
        case OptionAction.concat:
            return [...selectedOptions, option];
        case OptionAction.set: {
            const optionGroup = (0, exports.getOptionGroupForOption)({ item, option });
            const optionIdsFromGroup = new Set(optionGroup.options.map((o) => o.optionId));
            return [...selectedOptions.filter((o) => !optionIdsFromGroup.has(o.optionId)), option];
        }
        case OptionAction.remove:
            return selectedOptions.filter((o) => o.optionId !== option.optionId);
        default:
            return selectedOptions;
    }
};
exports.toggleOption = toggleOption;
//# sourceMappingURL=cart.js.map